import { createQueryKeys } from '@lukemorales/query-key-factory';

export const users = createQueryKeys('users', {
  activeUser: null,
  retrieve: (userId: string) => [userId],
});
